import { FormattedMessage } from "react-intl";
import { AlarmDetailsDto, useGetActiveObjectAlarmsQuery } from "../../../../services/alarm";
import { useMemo } from "react";
import { Badge } from "baseui/badge";
import { Block } from "baseui/block";
import { Banner } from "baseui/banner";
import { IAutomationObject } from "../../../types";

const ImportantAlarms = (props: IAutomationObject) => {
    const { data } = useGetActiveObjectAlarmsQuery({ resourceGroupId: props.resourceGroupId, objectId: props.id, includeChildren: true });

    const { deviceErrors, manOperations } = useMemo(() => {
        const deviceErrors = data?.filter((v: AlarmDetailsDto) => v.alarmClass.name === 'NoConnection' && !v.offTime);
        const manOperations = data?.filter((v: AlarmDetailsDto) => v.alarmClass.name === 'ManualMode' && !v.offTime);
        return { deviceErrors, manOperations }
    }, [data])


    const deviceNcText = deviceErrors?.length === 1 ? <FormattedMessage id="P_Building.NotConnectedDevice" defaultMessage="Device not connected!" /> : <FormattedMessage id="P_Building.NotConnectedDevices" defaultMessage="Devices not connected!" />
    const manModeText = manOperations?.length === 1 ? <FormattedMessage id="P_Building.AggregateManMode" defaultMessage="Aggergate in Manual Mode!" /> : <FormattedMessage id="P_Building.AggregatesManMode" defaultMessage="Aggergates in Manual Mode!" />

    return (
        <Block className='alarms' display='flex' flexDirection='column' gridRowGap='0px'>
            {(deviceErrors && deviceErrors?.length > 0) && <Banner overrides={bannerOverrides} kind='warning'>
                <Badge color='warning' shape='pill' content={deviceErrors?.length} />  {deviceNcText}
            </Banner >
            }
            {(manOperations && manOperations?.length > 0) && <Banner overrides={bannerOverrides} kind='info'>
                <Badge color='accent' shape='pill' content={manOperations?.length} /> {manModeText}
            </Banner >}
        </Block>)
}

export default ImportantAlarms



const bannerOverrides = {
    Root: {
        style: ({ $theme }) => ({
            marginTop: '0px',
            marginBottom: '0px',
            marginLeft: '0px',
            marginRight: '0px',
        })
    }
}